import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  closeOverlay() {
    const overlayFrame = document.querySelector('#overlay-frame')
    if(!overlayFrame) { return }

    overlayFrame.innerHTML = ''
    overlayFrame.src = null
  }
}
